import * as Accordion from "@radix-ui/react-accordion";
import { ChevronDownIcon } from "@radix-ui/react-icons";
import { Table, Text } from '@radix-ui/themes';
import { useState } from 'react';
import PopupFrame from '.';
import ButtonTab2 from '@/page/history/components/ButtonTab2';
import { useTranslation } from 'react-i18next';
import Tables from '@/component/Tables';

const TableWhatPrice1 = () => {
	const { t } = useTranslation()

	const columns = [
		{
			key: "package",
			className: "w-1/3 text-center",
			title: t('rule_page.body_FQA.what_price.content.package'),
			className: '!text-[15px] text-center !sm:text-[17px] !text-[#854A0E] font-medium'
		},
		{
			key: "max_turn",
			className: "w-1/3 text-center",
			title: t('rule_page.body_FQA.what_price.content.price'),
			className: '!text-[15px] text-center !sm:text-[17px] !text-[#854A0E] font-medium'
		},
		{
			key: "purchase_time",
			className: "w-1/3 text-center",
			title: t('rule_page.body_FQA.what_price.content.number_of_bids'),
			className: '!text-[15px] text-center !sm:text-[17px] !text-[#854A0E] font-medium'
		},
	];

	const columns2 = [
		{
			title: t("rule_page.body_FQA.what_price.content.package"),
			dataIndex: "package",
			key: "package",
			align: "center",
			className: "w-1/3 text-center !text-[15px] !sm:text-[17px] !text-[#854A0E] font-medium",
		},
		{
			title: t("rule_page.body_FQA.what_price.content.text"),
			dataIndex: "text",
			key: "text",
			align: "center",
			className: "w-1/3 text-center !text-[15px] !sm:text-[17px] !text-[#854A0E] font-medium",
		},
		{
			title: t("rule_page.body_FQA.what_price.content.price"),
			dataIndex: "price",
			key: "price",
			align: "center",
			className: "w-1/3 text-center !text-[15px] !sm:text-[17px] !text-[#854A0E] font-medium",
		},

		{
			title: t("rule_page.body_FQA.what_price.content.bidding_times"),
			dataIndex: "bidding_times",
			key: "bidding_times",
			align: "center",
			className: "w-1/3 text-center !text-[15px] !sm:text-[17px] !text-[#854A0E] font-medium",
		},
		{
			title: t("rule_page.body_FQA.what_price.content.expiry_date"),
			dataIndex: "expiry_date",
			key: "expiry_date",
			align: "center",
			className: "w-1/3 text-center !text-[15px] !sm:text-[17px] !text-[#854A0E] font-medium",
		},
	];

	const data = [
		{
			key: "1",
			package: "TURN",
			price: t("rule_page.body_FQA.what_price.content.190_Ks"),
			number_of_bids: t("rule_page.body_FQA.what_price.content.1"),
		},
		{
			key: "2",
			package: "TURN 2",
			price: t("rule_page.body_FQA.what_price.content.390_Ks"),
			number_of_bids: t("rule_page.body_FQA.what_price.content.2"),
		},
		{
			key: "3",
			package: "TURN 5",
			price: t("rule_page.body_FQA.what_price.content.925_Ks"),
			number_of_bids: t("rule_page.body_FQA.what_price.content.5"),
		},
		{
			key: "1",
			package: "TURN 10",
			price: t("rule_page.body_FQA.what_price.content.1800_Ks"),
			number_of_bids: t("rule_page.body_FQA.what_price.content.10"),
		},
		{
			key: "1",
			package: "TURN 20",
			price: t("rule_page.body_FQA.what_price.content.3500_Ks"),
			number_of_bids: t("rule_page.body_FQA.what_price.content.20"),
		},
	];

	const data2 = [
		{
			key: "1",
			package: t("rule_page.body_FQA.what_price.content.daily"),
			text: "ON1",
			price: "299Ks",
			bidding_times: "2",
			expiry_date: `1 ${t("rule_page.body_FQA.what_price.content.day")}`,
		},

		{
			key: "2",
			package: t("rule_page.body_FQA.what_price.content.While_spitting"),
			text: "ON7",
			price: "1699Ks",
			bidding_times: "10",
			expiry_date: `7 ${t("rule_page.body_FQA.what_price.content.days")}`,
		},

		{
			key: "3",
			package: t("rule_page.body_FQA.what_price.content.monthly"),
			text: "ON30",
			price: "4999Ks",
			bidding_times: "30",
			expiry_date: `30 ${t("rule_page.body_FQA.what_price.content.days")}`,
		},
	];
	return (
		<>
			<div className="w-full overflow-x-auto ">
				<div className='bg-[#FEF6EE] rounded-2xl'>
					<Tables
						columns={columns}
						data={data || []}
						renderRow={(item) => (
							<Table.Row key={item.package} className="text-[15px]">
								<Table.Cell className="w-1/3 text-center">
									<Text className='text-[12px] sm:text-[15px] text-[#854A0E] font-medium'>{item.package}</Text>
								</Table.Cell>

								<Table.Cell className="w-1/3 text-center">
									<Text className='text-[12px] sm:text-[15px] text-[#854A0E] font-medium'>{item.price}</Text>
								</Table.Cell>

								<Table.Cell className="w-1/3 text-center">
									<Text className='text-[12px] sm:text-[15px] text-[#854A0E] font-medium'>{item.number_of_bids}</Text>
								</Table.Cell>
							</Table.Row>
						)}
					/>
				</div>
				<br />
				<div className='bg-[#FEF6EE] rounded-2xl'>
					<Tables
						columns={columns2}
						data={data2 || []}
						className="w-full text-[15px]"
						renderRow={(item) => (
							<Table.Row key={item.package} className="text-[15px]">
								<Table.Cell className=" text-center">
									<Text className='text-[12px] sm:text-[15px] text-[#854A0E] font-medium'>{item.package}</Text>
								</Table.Cell>

								<Table.Cell className=" text-center">
									<Text className='text-[12px] sm:text-[15px] text-[#854A0E] font-medium'>{item.text}</Text>
								</Table.Cell>

								<Table.Cell className=" text-center">
									<Text className='text-[12px] sm:text-[15px] text-[#854A0E] font-medium'>{item.price}</Text>
								</Table.Cell>
								<Table.Cell className=" text-center">
									<Text className='text-[12px] sm:text-[15px] text-[#854A0E] font-medium'>{item.bidding_times}</Text>
								</Table.Cell>
								<Table.Cell className=" text-center">
									<Text className='text-[12px] sm:text-[15px] text-[#854A0E] font-medium'>{item.expiry_date}</Text>
								</Table.Cell>
							</Table.Row>
						)}
					/>
				</div>
				<br />
			</div>
		</>
	)
}

// Each "/&n"-separated line becomes a row; lines starting with "• " get a hanging indent
const ContentLines = ({ content = "" }) => (
	<>
		{String(content)
			.split("/&n")
			.map((line, index) =>
				line.startsWith("• ") ? (
					<div key={index} className='flex gap-1.5'>
						<span>•</span>
						<span dangerouslySetInnerHTML={{ __html: line.slice(2) }} />
					</div>
				) : (
					<div key={index} dangerouslySetInnerHTML={{ __html: line }} />
				)
			)}
	</>
)

const ContentRule = () => {
	const { t } = useTranslation()
	return (
		<div>
			<Text as='p'
				className='font-bold text-[17px] sm:text-[23px] text-[#854A0E] pb-3'>
				{t('rule_page.body_rules.content_rules_title')}
			</Text>
			<Text as='p' className='font-bold text-[15px] sm:text-[20px] text-[#854A0E] pt-4 pb-3'>
				{t('rule_page.body_rules.content_rules_conditions')}
			</Text>
			<div className='text-[#854A0E] font-medium text-[15px] sm:text-[20px]'>
				<ContentLines content={t("rule_page.body_rules.content_rules").replace(/pt-34/g, "")} />
			</div>
		</div>
	)
}

const ContentBID = () => {
	const { t } = useTranslation()

	return (
		<div>
			<Text className='font-bold text-[17px] sm:text-[23px] text-[#854A0E]'>
				{t('rule_page.body_how_to_bid.content_bid_how_to_bid')}
			</Text>
			<Text as='p' className='font-bold text-[15px] sm:text-[20px] text-[#854A0E] pt-4 pb-3'>
				{t('rule_page.body_how_to_bid.content_bid_instruc')}
			</Text>
			<div className='text-[15px] sm:text-[20px] text-[#854A0E] font-medium'>
				<ContentLines content={t("rule_page.body_how_to_bid.content_instruc")} />
			</div>
			<Text as='p' className='font-bold text-[15px] sm:text-[20px] text-[#854A0E] pt-4 pb-3'>
				{t('rule_page.body_how_to_bid.content_bid_tips')}
			</Text>
			<div className='text-[15px] sm:text-[20px] text-[#854A0E] font-medium'>
				<ContentLines content={t("rule_page.body_how_to_bid.content_tips")} />
			</div>
		</div>
	)
}

const ContentFAQ = () => {
	const { t } = useTranslation()

	const items = [
		{
			title: t('rule_page.body_FQA.what_aution.title'),
			content: t('rule_page.body_FQA.what_aution.content'),
		},
		{
			title: t('rule_page.body_FQA.how_register.title'),
			content: t('rule_page.body_FQA.how_register.content'),
		},
		{
			title: t('rule_page.body_FQA.what_price.title'),
			content: '1',
		},
		{
			title: t('rule_page.body_FQA.how_play.title'),
			content: t('rule_page.body_FQA.how_play.content'),
		},
		{
			title: t('rule_page.body_FQA.what_prize.title'),
			content: t('rule_page.body_FQA.what_prize.content'),
		},
		{
			title: t('rule_page.body_FQA.how_won.title'),
			content: t('rule_page.body_FQA.how_won.content'),
		},
		{
			title: t('rule_page.body_FQA.if_prize.title'),
			content: t('rule_page.body_FQA.if_prize.content'),
		},
	];

	const renderContent = (content = "") => {
		return String(content)
			.replace(/<u\/>/g, "</u>")
			.replace(
				/<u>\(reverseauction\.com\.mm\)/g,
				`<u><a href="http://reverseauction.com.mm/" target="_blank" rel="noopener noreferrer">(reverseauction.com.mm)</a>`
			);
	};

	return (
		<div style={{ overflowX: 'hidden' }}>
			<Accordion.Root
				type="single"
				collapsible
				className="w-full"
			>
				{items.map((item, index) => (
					<Accordion.Item
						key={index}
						value={`item-${index}`}
						className="border-b border-[#F4D4B3]"
					>
						<Accordion.Header>
							<Accordion.Trigger
								className="
                flex
                w-full
                items-center
                justify-between
                py-5
                text-left
                text-[#854A0E]
             		text-[15px] sm:text-[20px]
                group
								font-semibold
              "
							>
								{item.title}

								<ChevronDownIcon
									className="
                  h-5
                  w-5
                  transition-transform
                  duration-300
                  group-data-[state=open]:rotate-180
                "
								/>
							</Accordion.Trigger>
						</Accordion.Header>

						<Accordion.Content
							className="
              overflow-hidden
              data-[state=open]:animate-slideDown
              data-[state=closed]:animate-slideUp
            "
						>
							{item.content === '1' ? <TableWhatPrice1 /> :
								<div className="p-5 text-[#854A0E] bg-[#FEF6EE] font-medium rounded-2xl mb-[4%] 
								text-[15px] sm:text-[20px]">
									<ContentLines content={renderContent(item.content)} />
								</div>
							}
						</Accordion.Content>
					</Accordion.Item>
				))}
			</Accordion.Root>
		</div>)
}

export default function Rule({
	open, onOpenChange
}) {
	const { t } = useTranslation()
	const [active, setActive] = useState("rule");

	const tabs = [
		{
			id: "rule",
			label: t('rule_page.rule'),
		},
		{
			id: "how_to_BID",
			label: t('rule_page.how_to _bid'),
		},
		{
			id: "faq",
			label: "FAQ",
		},
	];


	return (
		<PopupFrame
			open={open}
			onOpenChange={onOpenChange}
			title={t("rule_page.rule")}
		>
			<div className="">
				<ButtonTab2 data={tabs} active={active} setActive={setActive} classNameButton='!text-[12.5px] sm:!text-[20px]' />
				{active === 'rule' && <ContentRule />}
				{active === 'how_to_BID' && <ContentBID />}
				{active === 'faq' && <ContentFAQ />}
			</div>
		</PopupFrame>
	)
}
